import React, { useEffect } from 'react';
import { Backdrop, Divider, Icon, Typography } from "../../index";
import { SwipeableContainer } from "../../mybswh"
import './drawer.scss';

export const Drawer = ({
    children,
    className,
    title,
    open,
    toggle = () => { }
}) => {

    useEffect(() => {
        if (document) {
            document.body.style.overflow = open ? "hidden" : "";
        }
        return () => {
            if (document) document.body.style.overflow = "";
        };
    }, [open]);

    const handleTouch = (evt, dir, phase, swipetype, distance) => {
        if (dir === "down" || swipetype === "down")
            toggle();
    };

    const drawerClasses = [
        `bsw-drawer`,
        `${className ? className : ''}`,
        `${open ? 'show' : 'hide'}`
    ].join(' ');

    return (<>
        {open && <>
            <div className="bsw-drawer__scrim">
                <Backdrop onClick={toggle} />
            </div>
            <div className={drawerClasses}>
                <SwipeableContainer handleTouch={handleTouch} threshold={500} restraint={100} allowedTime={500}></SwipeableContainer>
                <div className="bsw-drawer__header">
                    {title &&
                        <div className="bsw-drawer__header-title">
                            <Typography
                                type="body-02"
                                bold={true}
                                color="$color-primary-a2"
                                textAlign="center"
                                tag="div"
                            >
                                {title}
                            </Typography>
                        </div>
                    }
                    <div className="bsw-drawer__header-close">
                        <button type="button" className="bsw-drawer__close-btn" aria-label="close" onClick={toggle}>
                            <Icon name="x" />
                        </button>
                    </div>
                </div>
            
                {title && 
                    <div className="bsw-drawer__divider">
                        <Divider size="auto" mTop="small" mLeft="none" mRight="none" mBottom="none" />
                    </div>
                }

                <div className="bsw-drawer__body">
                    {children}
                </div>
            </div>
        </>}
    </>);
}